import React from 'react';

import { SnackbarContent as MuiSnackbarContent } from '@material-ui/core';

const SnackbarContent = ({ ...props }) => <MuiSnackbarContent {...props} />

export default SnackbarContent;
